//----- AUTOGENERATED (changes will be overwritten) -------
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric from "../Foreign.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dForm$dEditAsString from "../Restaumatic.Form.EditAsString/index.js";
import * as Unscramble from "../Unscramble/index.js";
const VatId = x => x;
const eqVatId = {eq: x => y => x === y};
const ordVatId = {compare: x => y => Data$dOrd.ordString.compare(x)(y), Eq0: () => eqVatId};
const editAsStringVatId = Restaumatic$dForm$dEditAsString.editAsStringString;
const newtypeVatId = {Coercible0: () => {}};
const genericVatId = {to: x => x, from: x => x};
const showVatId = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showStringImpl(v)]})({reflectSymbol: () => "VatId"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeVatId = {unsafeDecode: x => Unscramble.decodeString(x)};
const encodingOpts = /* #__PURE__ */ (() => (
  {
    sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
    unwrapSingleConstructors: true,
    unwrapSingleArguments: true,
    unwrapSingleRecordArguments: true,
    fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
  }
))();
const encodeVatId = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "VatId"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    }).encodeOpts(encodingOpts)
  }
))();
const decodeVatId = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericVatId)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "VatId"})({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
export {VatId, decodeVatId, editAsStringVatId, encodeVatId, encodingOpts, eqVatId, genericVatId, newtypeVatId, ordVatId, showVatId, unscrambleDecodeVatId};
